import {Env} from '../../env';

const api = {
  get: (sessionId: string) => `${Env.Endpoint}/${sessionId}/basket`,
  setRoom: (sessionId: string) => `${Env.Endpoint}/${sessionId}/basket/rooms`,
  setExtra: (sessionId: string) => `${Env.Endpoint}/${sessionId}/basket/extras`,
  deleteBasket: (sessionId: string) => `${Env.Endpoint}/${sessionId}/basket`,
};

export const BasketApi = api;
